import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { Badge } from "../Pill";
import { IMG } from "../../lib/images";

const CATS = [
  { name: "Trends", desc: "Bridal couture and high jewellery forecasts", badge: "Couture", img: IMG.bride3, href: "/edit?category=Editorial", span: "md:col-span-3" },
  { name: "Real Weddings", desc: "Palace soirees, beach varmalas and heritage unions", badge: "Featured", img: IMG.ceremony, href: "/edit?category=Real Weddings", span: "md:col-span-3" },
  { name: "Decor", desc: "Royal mandaps, chandeliers and tablescapes", badge: "Design", img: IMG.mandap, href: "/edit?category=Bespoke Decor", span: "md:col-span-2" },
  { name: "Floral", desc: "Jasmine cascades, pastel roses, botanical arches", badge: "Artistry", img: IMG.florals, href: "/edit?category=Bespoke Decor", span: "md:col-span-2" },
  { name: "Music", desc: "Shehnai, symphonies and baraat beats", badge: "Acoustics", img: IMG.fireworks, href: "/edit?category=Editorial", span: "md:col-span-2" },
  { name: "Celebrity Weddings", desc: "Inside Bollywood and global diaspora unions", badge: "Exclusive", img: IMG.pinkSherwani, href: "/edit?category=Celebrity Spotlights", span: "md:col-span-6" },
];

export default function Categories() {
  return (
    <section data-testid="categories-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><Badge tone="gold">Editorial Coverage</Badge></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl text-ink leading-[0.98]">
                Every detail of the<br className="hidden md:block" /> great Indian wedding
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-neutral-600 leading-relaxed">
              Trends, couples, decor, music, floral and celebrity celebrations, covered across India and every corner
              of the diaspora.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-6 gap-4 md:gap-5">
          {CATS.map((c, i) => (
            <Reveal key={c.name} delay={0.05 * i} className={c.span}>
              <Link
                to={c.href}
                data-testid={`category-card-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group relative block h-72 md:h-80 overflow-hidden rounded-[1.75rem]"
              >
                <img
                  src={c.img}
                  alt={c.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
                <div className="absolute top-5 left-5">
                  <Badge tone="gold">{c.badge}</Badge>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display uppercase text-2xl md:text-3xl text-cream leading-none">{c.name}</h3>
                    <p className="mt-2 text-xs text-cream/75 max-w-xs opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                      {c.desc}
                    </p>
                  </div>
                  <span className="w-11 h-11 shrink-0 rounded-full bg-cream/15 backdrop-blur flex items-center justify-center text-cream transition-all duration-300 group-hover:bg-champagne group-hover:text-ink group-hover:rotate-45">
                    <ArrowUpRight size={17} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
